export const HEX_ENC = "hex";
export const UTF8_ENC = "utf8";
//# sourceMappingURL=encoding.js.map